<template>
  <div class="table projects-table">
    <div class="thead">
      <div class="tr">
        <div class="th">
          Project Description
        </div>

        <div class="th">
          Development Strategy
        </div>

        <div class="th">
          Ward Location
        </div>

        <div class="th">
          Total Project Value
          <span class="block">(R'000)</span>
        </div>

        <div
          v-for="year in mtrefYears"
          :key="year.key"
          class="th"
        >
          Capital Budget

          <span class="block">{{ year.offset }}</span>

          <span class="block">{{ year.label }}</span>

          <span class="block">(R'000)</span>
        </div>
      </div>
    </div>

    <div class="tbody">
      <div
        v-for="(row, rIdx) in contentItem.rows"
        :key="rIdx"
        class="tr"
      >
        <div
          class="td"
          v-html="domPurify.sanitize(row.description)"
        />

        <div class="td">
          {{ row.strategy }}
        </div>

        <div class="td">
          {{ row.wardLocation }}
        </div>

        <div class="td !text-right">
          {{ formatValue(row.totalProjectValue) }}
        </div>

        <div
          v-for="year in mtrefYears"
          :key="year.key"
          class="td !text-right"
        >
          {{ formatValue(row.budget[year.key]) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useDomPurify, useStringFormatter } from '@/composables';
import { mtrefYears } from '@/const';

const domPurify = useDomPurify();
const stringFormatter = useStringFormatter();

defineProps({
  contentItem: {
    type: Object,
    required: true,
  },
});

const formatValue = (value) => {
  const formatted = stringFormatter.financialTableFormatters['currency'].format(value);

  // Zero and empty cells display as a dash in the finalised plan
  return formatted === '' || formatted === '0' ? '-' : formatted;
};
</script>
